module.exports = __webpack_public_path__ + "static/img/kefu.40127b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kefu.jpg
// module id = pmdT
// module chunks = 20